import { createAsyncThunk } from '@reduxjs/toolkit';
import { faqService } from '../../services';

const findAllFqa = () => createAsyncThunk('faq/findAll', async (optionId: string) => faqService.findAll(optionId));

export default {
  findAllFqa: findAllFqa(),
};
